import { Grid, Autocomplete, TextField } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import React from 'react';
import { getColumnValue } from './DbQueryColumnUtil';
import './queryDatabase.css';

const OutputColumnDropdown = props => {
  const Title = props => {
    return (
      <Grid className="title-grid" item xs={2}>
        <p className="title-font">
          {props.component === 'query_database_record'
            ? 'Return all values from column'
            : 'Output data from'}
        </p>
      </Grid>
    );
  };

  const isSelectedColumn = column => {
    return getColumnValue(column) === props.aData.value;
  };

  // Find the currently selected column object
  const selectedColumn = props.availableCols.find(column => isSelectedColumn(column));

  return (
    <Grid container className="margin-top">
      <Title component={props.component} />
      <Grid item error className="double-margin-top">
        <FormControl error={props.aData?.value == null}>
          <Autocomplete
            className="styled-autocomplete"
            value={selectedColumn || null}
            onChange={(event, newValue) => {
              const value = newValue ? getColumnValue(newValue) : null;
              props.onChange(value);
            }}
            options={props.availableCols}
            getOptionLabel={option => option.name || ''}
            renderInput={params => (
              <TextField
                {...params}
                placeholder="select column"
                variant="standard"
                size="small"
                InputProps={{
                  ...params.InputProps,
                  disableUnderline: true,
                }}
              />
            )}
            renderOption={(props, option) => (
              <li {...props} key={option.placeholderKey || option.realValue}>
                {option.name}
              </li>
            )}
            isOptionEqualToValue={(option, value) => {
              return getColumnValue(option) === getColumnValue(value);
            }}
            autoHighlight
            disableClearable={false}
            noOptionsText="No columns found"
          />
          {props.aData.value == null && props.validateKey ? (
            <FormHelperText>This field cannot be empty</FormHelperText>
          ) : (
            ''
          )}
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default OutputColumnDropdown;
